export default [
  {
    name: 'vehicleManagement',
    label: 'labels.vehicleManagement',
    permissionKey: 'vehicle_management',
    children: [
      {
        name: 'vehicle_administration',
        label: 'labels.vehicleModule.administration',
        permissionKey: 'vehicle_administration'
      },
      {
        name: 'vehicle_add',
        label: 'labels.vehicleAdd',
        permissionKey: 'vehicle_add'
      },
      {
        name: 'vehicle_edit',
        label: 'labels.vehicleEdit',
        permissionKey: 'vehicle_edit'
      },
      {
        name: 'vehicle_delete',
        label: 'labels.vehicleDelete',
        permissionKey: 'vehicle_delete'
      },
      {
        name: 'vehicle_archive',
        label: 'labels.vehicleArchive',
        permissionKey: 'vehicle_archive'
      },
      // {
      //   name: 'vehicle_restore',
      //   label: 'labels.vehicleRestore',
      //   permissionKey: 'vehicle_restore'
      // },
      {
        name: 'vehicleDocumentManagement',
        label: 'labels.vehicleDocumentManagement',
        permissionKey: 'vehicle_document_management',
        children: [
          {
            name: 'vehicle_document_add',
            label: 'labels.vehicleDocumentAdd',
            permissionKey: 'vehicle_document_add'
          },
          {
            name: 'vehicle_document_edit',
            label: 'labels.vehicleDocumentEdit',
            permissionKey: 'vehicle_document_edit'
          },
          {
            name: 'vehicle_document_delete',
            label: 'labels.vehicleDocumentDelete',
            permissionKey: 'vehicle_document_delete'
          },
          {
            name: 'vehicle_document_archive',
            label: 'labels.vehicleDocumentArchive',
            permissionKey: 'vehicle_document_archive'
          }
        ]
      },
      {
        name: 'vehiclePluginManagement',
        label: 'labels.vehiclePluginManagement',
        permissionKey: 'vehicle_plugin_management',
        children: [
          {
            name: 'vehicle_plugin_add',
            label: 'labels.vehiclePluginAdd',
            permissionKey: 'vehicle_plugin_add'
          },
          {
            name: 'vehicle_plugin_delete',
            label: 'labels.vehiclePluginDelete',
            permissionKey: 'vehicle_plugin_delete'
          }
          // {
          //   name: 'vehicle_plugin_restore',
          //   label: 'labels.vehiclePluginRestore',
          //   permissionKey: 'vehicle_plugin_restore'
          // }
        ]
      },
      {
        name: 'vehicleRepair',
        label: 'labels.vehicleRepairManagement',
        permissionKey: 'vehicle_repair_management',
        children: [
          {
            name: 'vehicle_repair_add',
            label: 'labels.vehicleRepairAdd',
            permissionKey: 'vehicle_repair_add'
          },
          {
            name: 'vehicle_repair_edit',
            label: 'labels.vehicleRepairEdit',
            permissionKey: 'vehicle_repair_edit'
          },
          {
            name: 'vehicle_repair_delete',
            label: 'labels.vehicleRepairDelete',
            permissionKey: 'vehicle_repair_delete'
          },
          {
            name: 'vehicle_repair_archive',
            label: 'labels.vehicleRepairArchive',
            permissionKey: 'vehicle_repair_archive'
          }
        ]
      },
      {
        name: 'remoocManagement',
        label: 'labels.remoocManagement',
        permissionKey: 'remooc_management',
        children: [
          {
            name: 'remooc_add',
            label: 'labels.remoocAdd',
            permissionKey: 'remooc_add'
          },
          {
            name: 'remooc_edit',
            label: 'labels.remoocEdit',
            permissionKey: 'remooc_edit'
          },
          {
            name: 'remooc_archive',
            label: 'labels.remoocArchive',
            permissionKey: 'remooc_archive'
          },
          // {
          //   name: 'remooc_restore',
          //   label: 'labels.remoocRestore',
          //   permissionKey: 'remooc_restore'
          // },
          {
            name: 'remooc_edit_pricing',
            label: 'labels.remoocEditPricing',
            permissionKey: 'remooc_edit_pricing'
          },
          {
            name: 'remooc_delete',
            label: 'labels.remoocDelete',
            permissionKey: 'remooc_delete'
          },
          {
            name: 'remoocDocumentManagement',
            label: 'labels.remoocDocumentManagement',
            permissionKey: 'remooc_document_management',
            children: [
              {
                name: 'remooc_document_add',
                label: 'labels.remoocDocumentAdd',
                permissionKey: 'remooc_document_add'
              },
              {
                name: 'remooc_document_edit',
                label: 'labels.remoocDocumentEdit',
                permissionKey: 'remooc_document_edit'
              },
              {
                name: 'remooc_document_delete',
                label: 'labels.remoocDocumentDelete',
                permissionKey: 'remooc_document_delete'
              },
              {
                name: 'remooc_document_archive',
                label: 'labels.remoocDocumentArchive',
                permissionKey: 'remooc_document_archive'
              }
              // {
              //   name: 'remooc_document_restore',
              //   label: 'labels.remoocDocumentRestore',
              //   permissionKey: 'remooc_document_restore'
              // }
            ]
          }
        ]
      },
      {
        name: 'remoocCategoryManagement',
        label: 'labels.remoocCategoryManagement',
        permissionKey: 'remooc_category_management',
        children: [
          {
            name: 'remooc_category_add',
            label: 'labels.remoocCategoryAdd',
            permissionKey: 'remooc_category_add'
          },
          {
            name: 'remooc_category_edit',
            label: 'labels.remoocCategoryEdit',
            permissionKey: 'remooc_category_edit'
          },
          {
            name: 'remooc_category_delete',
            label: 'labels.remoocCategoryDelete',
            permissionKey: 'remooc_category_delete'
          },
          {
            name: 'remooc_category_archive',
            label: 'labels.remoocCategoryArchive',
            permissionKey: 'remooc_category_archive'
          }
          // {
          //   name: 'remooc_category_restore',
          //   label: 'labels.remoocCategoryRestore',
          //   permissionKey: 'remooc_category_restore'
          // }
        ]
      }
    ]
  }
]
